// „Lecții suplimentare” pe Acasă (vederea din meniul „ce se vede”, AdminHome.jsx): elevii cu lecții
// suplimentare ai lunii alese în rândul de sus (lunile sunt într-un DropdownUI, nu mai sunt cartonașe
// ca grupele). Caseta e ca „Studenți” (clasele studentsUI); rândurile, ca în pagina de până acum:
// făcute / programate, cine e și ultimul apel din „De sunat”. Datele și filtrele le ține AdminHome.
import React from "react";

import { openPopup } from "../../Common/popupUIStore";
import StudentItem from "../../Common/StudentItem";
import { TagUI } from "../../UI";
import { monthColor, rowKind, rowStatus, rowTitle } from "./extraLessonsModel";
import "./extraLessons.scss";

function initialsOf(student) {
   const letters = [student?.firstName, student?.lastName]
      .map((w) => String(w || "").trim().charAt(0))
      .filter(Boolean)
      .join("");
   return (letters || "–").toUpperCase();
}

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

function Summary({ group }) {
   return (
      <TagUI.Group className="extraLessonsCard__summary">
         <TagUI tone="muted">{plural(group.ours, "al nostru", "ai noștri")}</TagUI>
         <TagUI tone="muted">{plural(group.other, "din altă școală", "din alte școli")}</TagUI>
         <TagUI tone={group.withNext ? "success" : "muted"}>{plural(group.withNext, "programat", "programați")}</TagUI>
         <TagUI tone="muted">{plural(group.extraDone, "lecție făcută", "lecții făcute")}</TagUI>
      </TagUI.Group>
   );
}

export default function ExtraLessonsCard({ months, month, query, loading, error, kind, onReload }) {
   // „Toate lunile”: fiecare lună cu titlul ei; altfel doar luna aleasă
   const shown = month === "all" ? months : months.filter((m) => m.month === month);
   const total = shown.reduce((n, m) => n + m.count, 0);

   const openStudent = (s) =>
      openPopup("studentDetails", { student: { id: s.id, firstName: s.firstName, lastName: s.lastName, phone: s.phone } });

   return (
      <div className="studentsUI extraLessonsCard">
         <div className="studentsUI__header extraLessonsCard__header">
            <h2 className="studentsUI__title">Lecții suplimentare</h2>
            {shown.length === 1 ? <Summary group={shown[0]} /> : null}
         </div>
         <p className="extraLessonsCard__hint">
            Ai noștri — din luna lecției a 31-a; din alte școli (bifa „Din altă școală” din fișa elevului) — din luna primei
            lecții la noi.
         </p>

         <div className="studentsUI__gridWrap">
            <div className="studentsUI__grid extraLessonsCard__grid">
               {loading ? <p className="studentsUI__empty">Se încarcă…</p> : null}
               {error ? (
                  <p className="studentsUI__empty extraLessons__error">
                     {error}{" "}
                     <button type="button" className="studentsUI__loadMore" onClick={onReload}>
                        Reîncearcă
                     </button>
                  </p>
               ) : null}

               {!loading &&
                  !error &&
                  shown.map((m) => (
                     <React.Fragment key={m.month}>
                        {month === "all" ? (
                           <div className="extraLessonsCard__month">
                              <h3>
                                 {m.label} · {plural(m.count, "elev", "elevi")}
                              </h3>
                              <Summary group={m} />
                           </div>
                        ) : null}
                        {m.students.map((s) => {
                           const status = rowStatus(s);
                           return (
                              <StudentItem
                                 key={`${m.month}-${s.id}`}
                                 className="extraLessons__student"
                                 student={s}
                                 color={monthColor(s.month)}
                                 initials={initialsOf(s)}
                                 onOpen={openStudent}
                                 highlightQuery={query}
                                 highlightClassName="studentItem__highlight"
                                 secondaryText={s.phone || "–"}
                                 phoneCopy
                                 statusText={status.text}
                                 statusTone={status.tone}
                                 statusTitle={rowTitle(s)}
                                 endAdornment={
                                    <div className="extraLessons__rowEnd" title={rowTitle(s)} data-student-id={s.id}>
                                       <span className="extraLessons__count">
                                          {s.extraDone}
                                          <small> / {s.extraDone + s.extraPlanned}</small>
                                       </span>
                                       <span className="extraLessons__who">{rowKind(s)}</span>
                                    </div>
                                 }
                              />
                           );
                        })}
                     </React.Fragment>
                  ))}

               {!loading && !error && total > 0 ? (
                  <div className="studentsUI__footer">
                     <span className="studentsUI__counter">{plural(total, "elev", "elevi")}</span>
                  </div>
               ) : null}

               {!loading && !error && total === 0 ? (
                  <p className="studentsUI__empty">
                     {String(query || "").trim()
                        ? "Niciun elev găsit."
                        : kind === "other"
                          ? "Niciun elev din alte școli. Bifa „Din altă școală” se pune din fișa elevului."
                          : "Nu sunt elevi cu lecții suplimentare."}
                  </p>
               ) : null}
            </div>
         </div>
      </div>
   );
}
